export enum AnalysisStatusEnum {
	ANALYZED = 'ANALYZED',
	WAITING_ANALYSIS = 'WAITING_ANALYSIS',
}

export enum AnalysisStatusLabelEnum {
	ANALYZED = 'Analisado',
	WAITING_ANALYSIS = 'Aguardando Análise',
}
